import { render } from "./StatusMaster.vue?vue&type=template&id=12446f31&scoped=true"
import script from "./StatusMaster.vue?vue&type=script&lang=js"
export * from "./StatusMaster.vue?vue&type=script&lang=js"

import "./StatusMaster.vue?vue&type=style&index=0&id=12446f31&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12446f31"]])

export default __exports__